import {
  DONATION_HISTORY_LOADING,
  DONATION_HISTORY_SUCCESS,
  DONATION_HISTORY_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listSingleItemService } from "services/listSingleItemService";
import { donationHistoryUrl } from "api/apiUrls";

export const donationHistoryActions =
  (id: any) => async (dispatch: Dispatch) => {
    try {
      dispatch({ type: DONATION_HISTORY_LOADING, payload: true });
      const response = await listSingleItemService(
        `${donationHistoryUrl}`,
        `?user_id=${id}&device=web`
      );

      dispatch({ type: DONATION_HISTORY_SUCCESS, payload: response.data });
    } catch (err) {
      dispatch({ type: DONATION_HISTORY_FAILURE, payload: err });
    } finally {
      dispatch({ type: DONATION_HISTORY_LOADING, payload: false });
    }
  };
